import SqftJsonApi from "../../../../../../../api/sqftJsonApi";
import {CrownMoldingPositions} from "../../../../../../../helpers/cabinetsData/CrownMoldingPositions";

class CrownMoldingLoader {
  constructor(scene, loader, modelScale) {
    this.scene = scene;
    this.modelScale = modelScale;
    this.loader = loader;
  }

  loadCrownMolding = async (shapeId, cabinetMaterial) => {
    const crownMoldingPositions = CrownMoldingPositions.prepareCrownMoldingPositionsForTheShape(shapeId);

    if (crownMoldingPositions) {

      const crownMoldingPromises = crownMoldingPositions.map(async (crownMoldingPosition) => {
        try {
          const crownMoldingURL = await SqftJsonApi.getCrownMolding(crownMoldingPosition, {});
          //console.log("crownMoldingURL", crownMoldingURL);
          if (crownMoldingURL && crownMoldingURL.s3Url) {
            const moldingModel = await this.loadMoldingModel(crownMoldingURL.s3Url);
            // Apply cabinet material to crown molding
            moldingModel.traverse((child) => {
              if (child.isMesh) {
                child.material = cabinetMaterial;
              }
            });

            //v1 adjust model size to position in workspace
            moldingModel.position.set(
              crownMoldingPosition.cabinet_position.x * this.modelScale,//wallPosition.x / this.modelScale,
              crownMoldingPosition.posY * this.modelScale, //wallPosition.y / this.modelScale,
              crownMoldingPosition.cabinet_position.y * this.modelScale, //wallPosition.z / this.modelScale
            );

            //moldingModel.rotation.y = THREE.MathUtils.degToRad(molding.rotation);

            this.scene.add(moldingModel);
          } else {
            console.log(`No URL for crownMolding at position: ${crownMoldingPosition}`);
          }
        } catch (error) {
          console.error(`Failed to get crownMolding data for position ${crownMoldingPosition}`, error);
        }
      });

      return await Promise.all(crownMoldingPromises);
    }
  }

  loadMoldingModel(url) {
    return new Promise((resolve, reject) => {
      this.loader.load(
        url,
        (gltf) => resolve(gltf.scene),
        undefined,
        (error) => reject(error)
      );
    });
  }
}

export default CrownMoldingLoader;
